import { Theme } from '@mui/material/styles'
import { typography as muiTypography, ResponsiveStyleValue } from '@mui/system'

/** breakpoints.down('md') */
export function mobile(props: { theme: Theme }) {
	return props.theme.breakpoints.down('lg')
}

/** breakpoints.up('lg') */
export function desktop(props: { theme: Theme }) {
	return props.theme.breakpoints.up('lg')
}

/** Works the same as the `typography` prop in MUI */
export function typography(
	typography: ResponsiveStyleValue<string | undefined> | ((theme: Theme) => ResponsiveStyleValue<string | undefined>),
) {
	return (props: { theme: Theme }) => {
		const arg = { theme: props.theme, typography }
		return muiTypography(arg)
	}
}
